import React, {useState, useEffect, useRef, useCallback} from "react";
import {connect, useDispatch, useSelector} from "react-redux";
import classNames from "classnames";
import {useNavigate, useParams} from "react-router-dom";
import get from "lodash/get";
import map from "lodash/map";
import sumBy from "lodash/sumBy";
import filter from "lodash/filter";
import {

    getPayerUser,
    updateUserData,
    reduxSetPayerUser,
    getPayerUserForAdminLookup,
    getPaymentsToken,
    savePaymentsDataAdmin,
    deleteCard,
    transactionError,
    getAdminUserData,
    updatePayerUserData,
    onTransactionLoading,
    getPayerUserById,

} from "../../Actions/authActions";
import {
    subDomain, amountFormatterWithZero, saveLogRocketSession,
} from "../../utils";
import {
    formatCreditCardNumber, formatExpirationDate, formatCVC,
} from "../Payments/utils";
import PaymentSuccessPopup from "../Payments/paymentSuccessPopup";
import CustomCheckbox from "../../Components/CustomCheckBox";
import CustomRadio from "../../Components/CustomRadio";
import {withButtonLoader} from "../../helpers";
import CustomPopover from "../../Components/CustomPopover";
import CustomPopoverPayment from "../../Components/CustomPopoverPayment";
import ECheckManualEntry from "./ECheckManualEntry";
import CreditCardManualNmiFields from "./CreditCardManualNmiFields";
import CreditCardManualConvergeFields from "./CreditCardManualConvergeFields";
import DebitCardManualEntry from "./DebitCardManualEntry";
import CreditCardSwipeEntryConverge from "./CreditCardSwipeEntryConverge";
import CreditCardSwipeEntryNmi from "./CreditCardSwipeEntryNmi";

import "./AdminDashboard.css";
import CustomePopUp from "../../Components/customePopUp";
import AdminEditCardInfo from "../AdminPaymentEdit";
import AdminAddCardInfo from "../AdminPaymentAdd";
import AdminPaymentAddSwipe from "../AdminPaymentAddSwipe";
import {
    CreditCardIcon, DownArrowIcon, ECheckIcon, // HhaCardIcon,
    RefreshIcon, MousePointerIcon, AddCardIcon, SwipeCardIcon, CrossIcon,
} from "../../Components/Icons";
import "../AdminPay/Pay.css";
import {PaymentFactory} from "../../Payments/paymentFactory";
import {SAVE_TRANSACTION_LOADING, SAVE_TRANSACTION_ERROR, SAVE_TRANSACTION_SUCCESS} from "../../constants";
import CardExpiration from "../../Components/Forms/CardExpiration";
import {showPaymentError} from "../../Payments/errorHandler";
import AdminAddCardInfoNmi from "../AdminPaymentAddNmi";

const AdminPayerUser = (props) => {

    const {
        userAdmin, payerEmail, payerCell, patientNumber, sendBy, themeColor1, currentPage,
    } = props;
    const payerData = useSelector((state) => state.auth.payerUser);
    const [payerUser, setPayerUser] = useState({});
    const adminUser = useSelector((state) => state.auth.adminUser);
    const paymentGatewayType = useSelector((state) => state.auth.adminUser?.paymentGateways?.type);
    const params = useParams();
    const subdomain = params.subdomain || subDomain();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {patientPayer} = payerUser || {};
    const transactionLoading = useSelector((state) => state.auth.transactionLoading);
    const transactionError = useSelector((state) => state.auth.transactionError);
    const [showPopUpAutomatic, setShowPopUpAutomatic] = useState(false);
    const [title, setTitle] = useState("");
    const [showPopUp, setShowPopUp] = useState(false);
    const [target, setTarget] = useState(null);
    const [showDefaultChecked, setShowDefaultChecked] = useState("");
    const [selectedCardId, setSelectedCardId] = useState("");
    const [addEditSwipeMode, setAddEditSwipeMode] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [paymentMsg, setPaymentMsg] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
    const [selectedPayment, setSelectedPayment] = useState("");

    const [cardId, setCardId] = useState("");
    const defaultDoNotSavePaymentDetails = useSelector((state) => state.auth.adminUser.defaultDoNotSavePaymentDetails);

    const [isPaymentSaveDetails, setIsPaymentSaveDetails] = useState(!defaultDoNotSavePaymentDetails);
    useEffect(() => {
        setIsPaymentSaveDetails(!defaultDoNotSavePaymentDetails)
    }, [defaultDoNotSavePaymentDetails]);

    const [isDefault, setIsDefault] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [amountPaidPopup, setAmountPaidPopup] = useState(false);
    const [patientPayerInfo, setPatientPayerInfo] = useState([]);
    const [paymentData, setPaymentData] = useState({
        name: "", amount: "", card: "", exp: "", cvv: "",
    });
    const [accountType, setAccountType] = useState("");

    const [lastFourNumbers, setLastFourNumbers] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");

    const [disguisedSwipeNumber, setDisguisedSwipeNumber] = useState("");
    const [swiper, setSwiper] = useState(null);
    const [manual, setManual] = useState(null);
    const [isMultipleProviders, setIsMultipleProviders] = useState(false);


    const initSwipePayment = async () => {
        setManual({});
        const factory = new PaymentFactory();
        const newSwiper = await factory.create('SWIPE', {
            subdomain, adminUser, payerUser
        });
        newSwiper.init();
        setSwiper(newSwiper);
        document.addEventListener("cardSwiped", (e) => {
            setFirstName(e.detail.firstName);
            setLastName(e.detail.lastName);
            setLastFourNumbers(e.detail.lastFourNumbers);
            setDisguisedSwipeNumber(e.detail.disguisedSwipeNumber);
        });
    }

    const getNewPatientPayer = () => {
        const balancesPaid = [];
        map(patientPayerInfo, (i) => {
            balancesPaid.push({
                patientFirst: i.patientFirst,
                patientLast: i.patientLast,
                patientNumber: i.patientNumber,
                patientPayerId: i.patientPayerId,
                amountPaid: i.accountBalance < 0 ? 0 : i.accountBalance,
            });
        });
        return balancesPaid;
    }

    const postManualPayment = async (data) => {
        try {


            console.dir('payerUser #lskdjflksdf')
            console.dir(payerUser)
            //this postManualPayment handles at least the following
            // (1) eCheck if not isPaymentSaveDetails
            // (2) credit card if isPaymentSaveDetails
            // (3) credit card if !isPaymentSaveDetails
            // ?? maybe saved payment methods ??

            let res;
            if (data.response.ssl_result === "0" || data.response === '1') {
                // Converge & NMI approvals, respectively
                res = await props.savePaymentsDataAdmin({
                    paymentType,
                    transactionId: data.transactionId,
                    ssl_card_short_description: data.ssl_card_short_description, //Converge
                    ssl_card_number: data.ssl_card_number, //Converge
                    ssl_token: data.ssl_token, //Converge
                    isDefault: data.isDefault,
                    isPaymentSaveDetails: data.isPaymentSaveDetails,
                    userId: payerUser && payerUser.id || payerUser._id,
                    transactionsData: data.response,
                    sosCustomersId: get(userAdmin, "_id") || "",
                    patientPayer: getNewPatientPayer(),
                    isAdmin: true,
                    addedBy: {sosCustomersId: userAdmin.id || userAdmin._id},
                    initiatedBy: {sosCustomersId: userAdmin.id || userAdmin._id},
                    subdomain,
                }, dispatch);

                if (res instanceof Error) {
                    showResult("error", "Transaction successful, but error while saving transaction; please report this error to software support.");
                    console.error("Err #sldkfjlsdkfj");
                    dispatch({type: SAVE_TRANSACTION_ERROR});
                    return res;
                    // throw res;
                }
                if (res) {
                    localStorage.setItem('PENDING_TRANSACTION', JSON.stringify({
                        payerEmail: payerUser.payerEmail,
                        patientPayer: getNewPatientPayer(),
                        createdAt: data.response.ssl_txn_time,
                        transactionsData: data.response,
                        total: data.response.ssl_amount,
                        transactionId: data.transactionId,
                    }));
                    const updatedPatientPayers = patientPayer.map(ptPayer => {
                        const matchingPatientPayer = patientPayerInfo.find(ppInfo => ppInfo.patientPayerId === ptPayer.patientPayerId);
                        const unpaidBalance = parseFloat(ptPayer.accountBalance) - parseFloat(matchingPatientPayer.accountBalance);
                        return {
                            ...ptPayer, accountBalance: unpaidBalance,
                        }
                    });
                    const updatedPayerUser = {
                        ...payerUser, patientPayer: updatedPatientPayers,
                    };
                    localStorage.setItem("payerUser", JSON.stringify(updatedPayerUser));
                    dispatch(reduxSetPayerUser(updatedPayerUser));
                    setPayerUser(updatedPayerUser);
                    setPatientPayerInfo(updatedPatientPayers);
                    if (data.ssl_get_token === "Y" && !data.ssl_token_response === "SUCCESS") {
                        showResult("txnApprovedButPmtMethodNotStored", data);
                    } else {
                        showResult("approval");
                    }
                    setTimeout(() => {
                        dispatch(getPayerUserById(payerUser));
                        setPaymentType("");
                    }, 1000);
                }

                setPaymentData({
                    name: "", cardnumber: "", expiry: "", cvv: "",
                });
            } else {
                showResult("error", data.response);
                console.error("Err #dhduw4eu");
                dispatch({type: SAVE_TRANSACTION_ERROR});
            }

        } catch (err) {
            showResult("Transaction Error");
            console.error("Err #sldkfjlsdkfj");
            dispatch({type: SAVE_TRANSACTION_ERROR});
        }
    }

    const initManualPayment = async () => {
        if (adminUser && adminUser.paymentGateways) {
            const factory = new PaymentFactory();
            const newManual = await factory.create('MANUAL', {
                subdomain,
                adminUser,
                payerUser,
            }, handleSubmit);
            await newManual.init();
            setManual(newManual);
        }
    }

    const destroySwiper = () => {
        if (swiper) {
            swiper.destroy();
        }
    }

    const updatePaymentType = function (paymentType) {
        setPaymentType(paymentType);
        if (paymentType === "swipe" && paymentGatewayType === 'converge') {
            initSwipePayment();
        } else {
            destroySwiper();
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "instant"});
        // Initialize manual payment for:
        // 1. When paymentGateways becomes available (for saved payment methods and new payments)
        // 2. When addEditSwipeMode changes (for add/edit payment method flows)
        // 3. When paymentType changes to non-swipe (for new payment methods)
        // 4. When payerUser changes (to ensure we have current payer data)
        // Skip initialization only for Converge swipe mode
        if (paymentType !== "swipe" || paymentGatewayType === 'NMI') {
            initManualPayment();
        }
    }, [adminUser?.paymentGateways, addEditSwipeMode, paymentType, payerUser]);

    // Fetch fresh data on mount if Redux is empty but localStorage has data
    useEffect(() => {
        const localPayerUserObj = localStorage.getItem("payerUser");
        if (localPayerUserObj !== null) {
            const payerLocalStorage = JSON.parse(localPayerUserObj);
            // If Redux is empty but we have localStorage data, fetch fresh data from server
            if ((!payerData || Object.keys(payerData).length === 0) && payerLocalStorage && (payerLocalStorage.id || payerLocalStorage._id)) {
                dispatch(getPayerUserById(payerLocalStorage));
            }
        }
    }, []); // Run only on mount

    useEffect(() => { //if (payerData?.length) {
        if (payerData && Object.keys(payerData).length > 0) {
            setPayerUser(payerData);
        } else {

            const localPayerUserObj = localStorage.getItem("payerUser");
            // if (typeof localPayerUserObj !== undefined) {
            //     const payerLocalStorage = JSON.parse(localStorage.getItem("payerUser"));
            if (localPayerUserObj !== null) {
                const payerLocalStorage = JSON.parse(localPayerUserObj);
                setPayerUser(payerLocalStorage);
            } else {
                // No payer data available in Redux or localStorage
                // This is normal on initial page load before a patient is selected
                console.log("No payer data available yet");
            }
        }
    }, [payerData]);

    useEffect(() => {
        if (payerUser && payerUser.paymentMethods) {
            const {paymentMethods} = payerUser || "";
            const filterData = filter(paymentMethods, (p) => p.isDefault)[0];
            if (filterData && filterData._id) {
                setSelectedCardId(filterData._id);
            }
            setSelectedPayment(filterData);
        }
    }, [payerUser]);

    useEffect(() => {
        if (!Object.keys(userAdmin).length && currentPage === "payments") {
            dispatch(getAdminUserData(subdomain));
        }
    }, [!userAdmin]);

    useEffect(() => {
        if (payerUser) {
            setShowDefaultChecked(payerUser.paymentMethods);
        }
    }, [payerUser]);

    useEffect(() => {
        const PayerUser = JSON.parse(localStorage.getItem("payerUser"));
        if (PayerUser && PayerUser.patientPayer) {
            setPatientPayerInfo(PayerUser.patientPayer);
        }

        // -----  -----  -----  -----  -----  -----
        if (patientPayer && patientPayer.length > 0) {
            setIsMultipleProviders((() => {
                for (const ptPayer of patientPayer) {
                    if (
                        ptPayer.providerNumber !== patientPayer[0].providerNumber
                        || ptPayer.providerFirst !== patientPayer[0].providerFirst
                        || ptPayer.providerLast !== patientPayer[0].providerLast
                    ) {
                        return true;
                    }
                }
                return false;
            })());
        }
    }, [patientPayer]);

    const totalAmounts = () => {
        const total = sumBy(map(patientPayer, (i) => ({
            ...i, accountBalance: i ? Math.max(parseFloat(i.accountBalance), 0) : 0,
        })), "accountBalance");
        return total;
    };

    const totalAmountsPaid = (patientPayerInfo) => {
        let total = 0;
        for (let patient of patientPayerInfo) {
            if (patient && patient.accountBalance && !isNaN(patient.accountBalance)) {
                total += Math.max(parseFloat(patient.accountBalance), 0);
            }
        }
        return total;
    };

    const onRemoveDoc = () => {
        setShowPopUp(!showPopUp);
        if (cardId) {
            const data = {
                cardId, userId: payerUser.id || payerUser._id,
            };
            props.deleteCard(subdomain, data).then((res) => {
                if (res.payload) {
                    dispatch(getPayerUserById(payerUser));
                    // dispatch(getPayerUserForAdminLookup(data1, navigate));
                }
            });
        }
    };

    const handleAmountBeingPaid = async (type) => {
        if (totalAmountsPaid(patientPayerInfo) === 0) {
            setAmountPaidPopup(!amountPaidPopup);
        } else {
            if (type === "swipe" && paymentGatewayType === 'converge') {
                initSwipePayment();
            } else {
                destroySwiper();
            }
            setPaymentType(type);
        }
    };

    const handleClosePopUp = () => {
        setShowPopUp(false);
        setCardId("");
        setAmountPaidPopup();
    };

    const handlePopUp = (event, i) => {
        setShowPopUp(!showPopUp);
        setTarget(event.target);
        setCardId(i._id);
    };


    const createError = function (err) {
        let error = [err.errorCode, err.errorName, err.errorMessage];
        let errorMessage = error.join(' ').trim();
        if (errorMessage.length > 0) {
            return errorMessage;
        }
        return err.ssl_result_message;
    }

    function showResult(status, err) {
        if (status === "approval") {
            // Check if we're in "Add payment method" mode
            if (['add', 'swipe'].includes(addEditSwipeMode)) {
                setPaymentMsg("addSuccessful");
            } else {
                setPaymentMsg("successful");
            }
            setPaymentStatus("approval");
            saveLogRocketSession({ eventType: "payment_success" });
        } else if (status === "txnApprovedButPmtMethodNotStored") {
            setPaymentMsg("The payment was successful. Unable to store payment method at this time.");
            setPaymentStatus("approval");
            saveLogRocketSession({ eventType: "payment_success" });
        } else if (status === "failure" || status === "error") {
            setPaymentMsg(`${showPaymentError(err)}`);
            setPaymentStatus("error");
            saveLogRocketSession({ eventType: "payment_error", metadata: { error: err } });
        }
        setOpenModal(true);
    }

    const handleEditInfo = () => {
        setAddEditSwipeMode("edit");
        setSelectedPayment(selectedPayment);
    };

    const handleAddCardInfo = () => {
        setAddEditSwipeMode("add");
        setIsPaymentSaveDetails(true);
        const newPaymentMethodObj = {
            "addedBy": {
                "sosCustomersId": userAdmin.id || userAdmin._id
            },
            "paymentType": "creditCard",
            "ssl_first_name": "",
            "ssl_last_name": "",
            "ssl_company": "",
            "ssl_bank_account_number": "",
            "ssl_bank_account_type": "",
            "ssl_card_number": "",
            "ssl_card_short_description": "",
            "ssl_token": "",
            "isDefault": false,
            "_id": ""
        }
        // setSelectedPayment(selectedPayment);
        setSelectedPayment(newPaymentMethodObj);
    };

    const handleECheck = () => {
        setAddEditSwipeMode("add");
        setSelectedPayment({
            "addedBy": {
                "sosCustomersId": userAdmin.id || userAdmin._id
            },
            "paymentType": "eCheck",
            "firstName": "",
            "lastName": "",
            "companyName": "",
            "bankAccountType": "",
            "bankName": "",
            "bankRoutingNumber": "",
            "bankAccountNumber": "",
            "ssl_recurring_id": "",
            "isDefault": false,
            "_id": ""
        });
    };
    const handleSwipeAddCardInfo = (e, specifiedValue) => {
        if (paymentGatewayType === 'NMI') {
            if (specifiedValue) {
                setAddEditSwipeMode(specifiedValue);
                if (specifiedValue === 'add') {
                    setPaymentType("creditCard");
                }
                if (specifiedValue === 'swipe') {
                    setPaymentType("swipe");
                }
            } else if (addEditSwipeMode === "add") {
                setAddEditSwipeMode("swipe");
                setPaymentType("swipe");
            } else if (addEditSwipeMode === "swipe") {
                setAddEditSwipeMode("add");
                setPaymentType("creditCard");
            }
            const newPaymentMethodObj = {
                "addedBy": {
                    "sosCustomersId": userAdmin.id || userAdmin._id
                },
                "paymentType": "creditCard",
                "ssl_first_name": "",
                "ssl_last_name": "",
                "ssl_company": "",
                "ssl_bank_account_number": "",
                "ssl_bank_account_type": "",
                "ssl_card_number": "",
                "ssl_card_short_description": "",
                "ssl_token": "",
                "isDefault": false,
                "_id": ""
            }
            // setSelectedPayment(selectedPayment);
            setSelectedPayment(newPaymentMethodObj);

            return;
        }
        if (paymentGatewayType === 'converge') {
            setAddEditSwipeMode("swipe");

            const newPaymentMethodObj = {
                "addedBy": {
                    "sosCustomersId": userAdmin.id || userAdmin._id
                },
                "paymentType": "creditCard",
                "ssl_first_name": "",
                "ssl_last_name": "",
                "ssl_company": "",
                "ssl_bank_account_number": "",
                "ssl_bank_account_type": "",
                "ssl_card_number": "",
                "ssl_card_short_description": "",
                "ssl_token": "",
                "isDefault": false,
                "_id": ""
            }
            // setSelectedPayment(selectedPayment);
            setSelectedPayment(newPaymentMethodObj);
        }
    };

    const handleInputChange = ({target}) => {
        if (target.name === "cardnumber") {
            target.value = formatCreditCardNumber(target.value);
        } else if (target.name === "expiry") {
            target.value = formatExpirationDate(target.value);
        } else if (target.name === "cvc") {
            target.value = formatCVC(target.value);
        } else if (target.name === "accountType") {
            setAccountType(target.value)
        }
        setPaymentData({...paymentData, [target.name]: target.value});
    };

    const latestRef = useRef({
        subdomain,
        adminUser,
        payerUser,
        manual,
        isPaymentSaveDetails,
        isDefault,
        paymentType,
        selectedPayment,
        paymentData,
        patientPayerInfo,
    });

    // keep ref up to date
    useEffect(() => {
        latestRef.current = {
            subdomain,
            adminUser,
            payerUser,
            manual,
            isPaymentSaveDetails,
            isDefault,
            paymentType,
            selectedPayment,
            paymentData,
            patientPayerInfo,
        };
    }, [
        subdomain,
        adminUser,
        payerUser,
        manual,
        isPaymentSaveDetails,
        isDefault,
        paymentType,
        selectedPayment,
        paymentData,
        patientPayerInfo,
    ]);


    const handleSubmit = async (e, isNmi = false) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        // pull latest info from the ref:
        const {
            subdomain,
            adminUser,
            payerUser,
            manual,
            isPaymentSaveDetails,
            isDefault,
            paymentType,
            selectedPayment,
            paymentData,
            patientPayerInfo,
        } = latestRef.current;

        // Check for NMI validation errors before proceeding
        if (isNmi && manual && paymentType === 'creditCard') {
            const validationCheck = manual.checkValidationErrors();
            if (validationCheck.hasErrors) {
                showResult("error", validationCheck.error);
                dispatch({type: SAVE_TRANSACTION_ERROR});
                return;
            }
        }

        let totaledAmount, formattedAmount;
        if (!['add', 'swipe'].includes(addEditSwipeMode)) {
            totaledAmount = totalAmountsPaid(patientPayerInfo);
            formattedAmount = amountFormatterWithZero(totaledAmount);
        }
        if (['add', 'swipe'].includes(addEditSwipeMode)) {
            totaledAmount = 0;
            formattedAmount = '0.00';
        }

        dispatch({type: SAVE_TRANSACTION_LOADING});
        let formData;
        if (e?.target?.elements) {
            formData = [...e.target.elements]
                .filter((d) => d.name)
                .reduce((acc, d) => {
                    if (["isPaymentSaveDetails", "isDefault"].includes(d.name)) {
                        acc[d.name] = d.value === "on";
                    } else {
                        acc[d.name] = d.value;
                    }
                    return acc;
                }, {});
        } else {
            formData = paymentData;
        }

        const payerEmail = get(payerUser, "payerEmail") || "";
        let data = {
            amount: formattedAmount,
            payerEmail,
            subdomain,
            paymentMethod: {
                paymentType,
            },
        };
        if (!paymentType && !selectedPayment) {
            showResult("error", 'Please select a payment method.');
            dispatch({type: SAVE_TRANSACTION_ERROR});
            return;
        }
        if (!paymentType && selectedPayment) {
            if (totaledAmount === 0 && addEditSwipeMode === '') {
                setAmountPaidPopup(!amountPaidPopup);
                dispatch({type: SAVE_TRANSACTION_ERROR});
                return;
            }
            data.isPaymentSaveDetails = isPaymentSaveDetails;
            data.isDefault = selectedPayment.isDefault;
            if (paymentGatewayType === 'converge') {
                if (selectedPayment.ssl_recurring_id) {
                    data = {
                        ...data,
                        isEcheck: true,
                        firstName: selectedPayment.ssl_first_name,
                        lastName: selectedPayment.ssl_last_name,
                        companyName: selectedPayment.ssl_company,
                        bankAccountType: selectedPayment.ssl_bank_account_type,
                        ssl_recurring_id: selectedPayment.ssl_recurring_id
                    }
                } else {
                    data = {
                        ...data,
                        isEcheck: false,
                        ssl_token: selectedPayment.ssl_token
                    }
                }
            }
            if (paymentGatewayType === 'NMI') {
                if (selectedPayment.paymentType === 'eCheck') {
                    data = {
                        ...data,
                        isEcheck: true,
                        firstName: selectedPayment.firstName,
                        lastName: selectedPayment.lastName,
                        companyName: selectedPayment.companyName,
                        bankAccountType: selectedPayment.bankAccountType,
                        paymentMethodId: selectedPayment._id,
                    }
                } else {
                    // Handle credit card and swipe payment methods (both are card-based)
                    if (selectedPayment.paymentType === 'creditCard' || selectedPayment.paymentType === 'swipe' || selectedPayment.paymentType === '') {
                        data = {
                            ...data,
                            isEcheck: false,
                            firstName: selectedPayment.firstName,
                            lastName: selectedPayment.lastName,
                            paymentMethodId: selectedPayment._id,
                        }
                    }
                }
            }

        } else {
            data.isPaymentSaveDetails = isPaymentSaveDetails;
            data.isDefault = isDefault;

            console.dir('data');
            console.dir(data);
            console.dir('paymentType');
            console.dir(paymentType);
            if (paymentType === "eCheck") {
                const isPersonalAccount = formData.accountType === "0";
                const isBusinessAccount = formData.accountType === "1";
                data = {
                    ...data,
                    isEcheck: true,
                    firstName: isPersonalAccount ? formData.accountFirstName : "",
                    lastName: isPersonalAccount ? formData.accountLastName : "",
                    companyName: isBusinessAccount ? formData.companyName : "",
                    bankAccountType: formData.accountType,
                    bankName: formData.bankName,
                    bankRoutingNumber: formData.bankRoutingNumber,
                    bankAccountNumber: formData.bankAccountNumber
                }
            } else { // 'creditCard' 'swipe' ?'hhaCard'? ?'debitCard'?
                console.dir('data');
                console.dir(data);
                console.dir('paymentType');
                console.dir(paymentType);

                data = {
                    ...data,
                    isEcheck: false,
                    firstName: formData.cardFirstName || "",
                    lastName: formData.cardLastName || "",
                    expirationDate: formData && formData.expiry ? formData.expiry.replace(/\//g, "") : "",
                    cardNumber: formData && formData.cardnumber,
                    cvv: formData && formData.cvc ? formData.cvc : "",
                    zip: formData.billingZip || ""
                };
            }
        }


        manual.data = {...manual.data, subdomain, adminUser, payerUser, ...data};
        manual.data.patientPayer = getNewPatientPayer();

        manual.pay(e).then((res) => {
            if (!res) {
                showResult('error', 'No response received from payment gateway');
                dispatch({type: SAVE_TRANSACTION_ERROR});
                return;
            }
            if (res.data) {
                res = {...res, ...res.data};
            }
            if (!res.response) {
                res.response = {...res};
            }
            if (paymentGatewayType === 'converge') {
                if (data.isEcheck && data.isPaymentSaveDetails || data.isEcheck && selectedPayment.ssl_recurring_id) {
                    if (res.response.ssl_result === "0") {
                        //ssl_result==="0" if it's a successful transaction
                        let delay;
                        if (res.response.ssl_recurring_id !== "") {
                            //ssl_recurring_id !=="" if eCheck payment method is successfully stored
                            showResult("approval");
                            delay = 1000;
                        } else {
                            showResult("txnApprovedButPmtMethodNotStored", res.response);
                            delay = 2000;
                        }
                        setTimeout(() => {
                            dispatch(getPayerUserById(payerUser));
                            dispatch({type: SAVE_TRANSACTION_SUCCESS});
                            setPaymentType("");
                            setOpenModal(false);
                        }, delay);
                    } else {
                        showResult("failure", res.response);
                        dispatch({type: SAVE_TRANSACTION_ERROR});
                    }
                } else {
                    //this else block handles at least the following
                    // (1) eCheck if not isPaymentSaveDetails
                    // (2) credit card if isPaymentSaveDetails
                    // (3) credit card if !isPaymentSaveDetails
                    // ?? maybe saved payment methods ??
                    res.isDefault = data.isDefault;
                    res.isPaymentSaveDetails = data.isPaymentSaveDetails;
                    postManualPayment(res);

                    dispatch({type: SAVE_TRANSACTION_SUCCESS});
                }
            }
            if (paymentGatewayType === 'NMI') {
                if (res instanceof Error) {
                    showResult("error", "Transaction successful, but error while saving transaction; please report this error to software support.");
                    console.error("Err #sldkfjlsdkfj");
                    dispatch({type: SAVE_TRANSACTION_ERROR});
                    return res;
                    // throw res;
                }
                if (res?.response === '1') {
                    localStorage.setItem('PENDING_TRANSACTION', JSON.stringify({
                        payerEmail: payerUser.payerEmail,
                        patientPayer: getNewPatientPayer(),
                        total: data.amount,
                        transactionId: res?.transactionid,
                    }));
                    const updatedPatientPayers = patientPayer.map(ptPayer => {
                        const matchingPatientPayer = patientPayerInfo.find(ppInfo => ppInfo.patientPayerId === ptPayer.patientPayerId);
                        const unpaidBalance = parseFloat(ptPayer.accountBalance) - parseFloat(matchingPatientPayer.accountBalance);
                        return {
                            ...ptPayer, accountBalance: unpaidBalance,
                        }
                    });
                    const updatedPayerUser = {
                        ...payerUser, patientPayer: updatedPatientPayers,
                    };
                    localStorage.setItem("payerUser", JSON.stringify(updatedPayerUser));
                    dispatch(reduxSetPayerUser(updatedPayerUser));
                    setPayerUser(updatedPayerUser);
                    setPatientPayerInfo(updatedPatientPayers);
                    // if (data.ssl_get_token === "Y" && !data.ssl_token_response === "SUCCESS") {
                    //     showResult("txnApprovedButPmtMethodNotStored", data);
                    // } else {
                    // }
                    showResult("approval");
                    dispatch({type: SAVE_TRANSACTION_SUCCESS});
                    setTimeout(() => {
                        dispatch(getPayerUserById(payerUser));
                        setPaymentType("");
                    }, 1000);
                } else {
                    showResult("error", res);
                    dispatch({type: SAVE_TRANSACTION_ERROR});
                }

                setPaymentData({
                    name: "", cardnumber: "", expiry: "", cvv: "",
                });


            }
        }).catch((err) => {
            console.dir("err line 500");
            console.dir(err);
            if (!err) {
                showResult("error", "An unexpected error occurred. Please try again.");
            } else if (err.isAxiosError) {
                showResult("error", err.response?.data || err.message || err);
            } else {
                showResult("error", err);
            }
            dispatch({type: SAVE_TRANSACTION_ERROR});
        });
    };

    const onCloseModal = () => {
        setOpenModal(false);
        // If we successfully saved a payment method, also close the "Add Payment Method" component
        if (paymentStatus === "approval" && ['add', 'swipe'].includes(addEditSwipeMode)) {
            setAddEditSwipeMode("");
        }
    };

    const onDefaultChecked = (e, c, i) => {
        let payerUserchecked = [...payerUser.paymentMethods];
        let updateDefaultCard = [];
        const updatedPayerUser = payerUser;
        const selectedPayerId = e.target.checked ? payerUserchecked[i]._id : "";
        setShowDefaultChecked(payerUserchecked[i]);
        setSelectedCardId(selectedPayerId);

        map(payerUserchecked, (p) => {
            const defaultCard = p;
            if (p._id === c._id) {
                defaultCard.isDefault = e.target.checked;
            } else {
                defaultCard.isDefault = false;
            }
            updateDefaultCard.push(defaultCard);
        });
        setShowDefaultChecked(updateDefaultCard);

        updatedPayerUser.paymentMethods = showDefaultChecked;
        dispatch(updateUserData(updatedPayerUser));
        localStorage.setItem("payerUser", JSON.stringify(updatedPayerUser));
    };

    const onAmountChangeHandler = (e, index) => {
        const inputValues = [...patientPayerInfo];
        const value = e.target.value
            .replace(/[^0-9.]/g, "")
            .replace(".", "x")
            .replace(/\./g, "")
            .replace("x", ".");
        if (inputValues && inputValues[index]) {
            inputValues[index].accountBalance = value;
        }
        setPatientPayerInfo(inputValues);
    };

    const setAmountsToZero = () => {
        const inputValues = [...patientPayerInfo];
        inputValues.forEach((v, index) => {
            if (inputValues && inputValues[index]) {
                inputValues[index].accountBalance = "0.00";
            }
        });
        setPatientPayerInfo(inputValues);
    };

    const handleClick = (e) => {
        e.target.select();
    };

    const handlePay = async (e) => {
        try {
            swiper.data.isPaymentSaveDetails = isPaymentSaveDetails;
            swiper.data.isDefault = isDefault;
            swiper.data.patientPayer = getNewPatientPayer();
            swiper.data.amount = amountFormatterWithZero(totalAmountsPaid(patientPayerInfo));
            let res = await swiper.pay(e);
            if (res?.data?.message === 'Transaction successful') {
                showResult("approval");
                setTimeout(() => {
                    dispatch(getPayerUserById(payerUser));
                    dispatch({type: "PAYUSER_SUCCESS"});
                    setPaymentType("");
                    setOpenModal(false);
                    swiper.destroy();
                }, 1000);
            } else {
                showResult("failure", res?.data || res);
            }
        } catch (err) {
            console.error("err #hpay3k2j", err);
            if (err.isAxiosError) {
                showResult("error", err.response?.data || err.message || err);
            } else {
                showResult("error", err);
            }
            dispatch({type: SAVE_TRANSACTION_ERROR});
        }
    }


    // const handlePayNmi = async (e) => {
    //     swiper.data.isPaymentSaveDetails = isPaymentSaveDetails;
    //     swiper.data.isDefault = isDefault;
    //     swiper.data.patientPayer = getNewPatientPayer();
    //     swiper.data.amount = amountFormatterWithZero(totalAmountsPaid(patientPayerInfo));
    //     let res = await swiper.pay(e);
    //     // if (res.data.message === 'Transaction successful') {
    //     if (res.data.message === 'Transaction successful') {
    //         showResult("approval");
    //         setTimeout(() => {
    //             dispatch(getPayerUserById(payerUser));
    //             dispatch({type: "PAYUSER_SUCCESS"});
    //             setPaymentType("");
    //             setOpenModal(false);
    //             swiper.destroy();
    //         }, 1000);
    //     } else {
    //         showResult("failure", res.data);
    //     }
    // }

    const displayName = (patient) => {
        if (patient && patient.patientFirst && patient.patientFirst.length > 10
            || patient && patient.patientLast && patient.patientLast.length > 10) {
            return <p
                className="card-inner-text-font-payer payer-name-font">{patient && `${patient.patientFirst || ""} ${patient.patientMiddle || ""}${patient.patientLast}`}</p>;
        } else {
            return <p
                className="payer-name-font">{patient && `${patient.patientFirst || ""} ${patient.patientMiddle || ""} ${patient.patientLast}`}</p>
        }
    }

    const onClickPaymentMethod = (c) => {
        setSelectedCardId(c._id);
        setSelectedPayment(c);
        setIsPaymentSaveDetails(false);
    };

    const getPayerAmount = (index) => {
        if (!patientPayerInfo) {
            return null;
        }
        if (patientPayerInfo.length === 0) {
            return null;
        }
        return patientPayerInfo[index].accountBalance;
    }

    const formatValue = (e) => {
        if (e && e.target && e.target.value) {
            e.target.value = amountFormatterWithZero(e.target.value);
        }
    }

    // console.dir('payerUser #sldkfjlksdjfsd');
    // console.dir(payerUser);

    useEffect(()=>{
        console.dir('manual was changed')
        console.dir(manual)
    },[manual]);

    return (<>

        <div className="intake-content-admin">
            <div id="parentForSwipeInput"></div>
            <div className="mb-4 payerinfo">
                <div className="patientId col-md-5">
                    {payerUser && payerUser.payerFirst}{` `}{payerUser && payerUser.payerLast}
                </div>
                <div className="confirmation-email col-md-7 ">
                    {payerUser?.payerEmail?.startsWith("*fake*") ? `This payer has no email in the system for receipts` : `Receipts will be sent to ${payerUser && payerUser.payerEmail}`}
                </div>
            </div>
            <div className=" intake-content-inner">
                <div
                    className={classNames(" homeexisting-patient-box pay-card position-relative intake-content-box", patientPayer ? "" : "empty-amount-due")}
                >
                    <div className="justify-content-between">
                        <div className="d-flex hommeexisting-hoiz-text">
                            <div className="pay-left">
                                Account Balance
                            </div>
                            <div className="pay-center">
                                Payment Amount
                            </div>
                        </div>
                        {/* <div className="hommeexisting-large-text hommeexisting-hoiz-text">
                ID
              </div> */}
                    </div>

                    <div>

                        <div className="homeexisting-inner-card">

                            {map(patientPayer, (a, index) => {
                                return (<span key={index + a.patientPayerId + parseInt(a.accountBalance)}>
                      <div className="d-flex align-items-center pay-large-inner justify-content-between">
                        <p
                            className="pay-account-balance"
                            style={{
                                paddingLeft: 0, fontWeight: "normal"
                            }}
                        >{a && `$${amountFormatterWithZero(Math.max(a.accountBalance, 0))}`}</p>
                        <input
                            type="text"
                            className="pay-control custom-input-border-css"
                            id={`accountbalance-${index}`}
                            aria-describedby="emailHelp"
                            placeholder="$0.00"
                            onBlur={(e) => formatValue(e)}
                            // value={`${getPayerAmount(index) || a.accountBalance || ""}`}
                            defaultValue={`${amountFormatterWithZero(Math.max(a.accountBalance, 0))}`}
                            onChange={(e) => onAmountChangeHandler(e, index)}
                            onClick={(e) => handleClick(e)}
                        />
                          {displayName(a)}

                      </div>
                      <div className="mt-1 provider-style credit-balance">
                        {a.accountBalance < 0 && `$${amountFormatterWithZero(-1 * a.accountBalance) || ""} CREDIT BALANCE`}
                      </div>
                     <div className="mt-1 provider-style">
                          {a && isMultipleProviders && (a.providerFirst > "" || a.providerLast > "") &&
                              `Provider: ${a.providerFirst || ""} ${a.providerLast || ""}`
                          }
                    </div>
                      <div className="divider"/>
                    </span>);
                            })}
                            <div className="mt-1 provider-style">
                                {patientPayer && patientPayer.length > 0 && !isMultipleProviders &&
                                    (patientPayer[0].providerFirst > "" || patientPayer[0].providerLast > "") &&
                                    `Provider: ${patientPayer[0].providerFirst || ""} ${patientPayer[0].providerLast || ""}`
                                }
                            </div>
                            <div className="d-flex hommeexisting-large-inner-text">
                                <p>Total</p>
                                <p>${amountFormatterWithZero(totalAmountsPaid(patientPayerInfo))}</p>
                            </div>
                            {/* <div className="divider" />
                                    <div className="d-flex justify-content-end">
                                    <button type="submit" className="pay-custom-btn">
                                        Add to amount being paid
                                    </button>
                                    </div> */}
                        </div>

                    </div>
                </div>

                <div className="payment-patient-inner position-relative min-height-100-vh">
                    {addEditSwipeMode === "" && <div>
                        <div
                            className="hommeexisting-large-text hommeexisting-hoiz-text d-flex  justify-content-between">
                            <p>Amount Being Paid</p>
                            <p>Total Balance</p>

                        </div>
                        <div className="pay-inner-text container">
                            <div className="payment-amount d-flex  justify-content-between">
                                <p className="ml-5 payment-amount-style">
                                    ${amountFormatterWithZero(totalAmountsPaid(patientPayerInfo))}
                                </p>
                                <h6>${amountFormatterWithZero(totalAmounts())}</h6>
                            </div>
                            {paymentType === "creditCard" || paymentType === "eCheck" || paymentType === "swipe" ? (
                                <div>
                                    <div style={{display: "flex"}}>
                                        <div className="payment-patient-style">
                                            Select your payment method

                                        </div>
                                        <div className="cross-btn"
                                            // style={{marginTop: "-10px"}}
                                             onClick={() => {
                                                 updatePaymentType("");
                                             }}>
                                            <CrossIcon/>
                                        </div>
                                    </div>
                                    <div className=" payment-toggleable">
                                        <ul
                                            className="justify-content-center mb-3 nav nav-pills"
                                            id="pills-tab"
                                            role="tablist"
                                        >
                                            {adminUser.displayECheck && (<li
                                                className={classNames("nav-item chekbox-custom mr-2 me-2 rectangle nav-item-margin", paymentType === "eCheck" ? "active" : "")}
                                                role="presentation"
                                                onClick={() => updatePaymentType("eCheck")}
                                            >
                                                <a
                                                    className={`nav-link text-center`}
                                                    id="pills-home-tab"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-home"
                                                    role="tab"
                                                    aria-controls="pills-home"
                                                    aria-selected="true"
                                                >
                                                    <CustomRadio
                                                        // defaultChecked={paymentType === "eCheck"}
                                                        checked={paymentType === "eCheck"}
                                                        onChange={(e) => updatePaymentType("eCheck")}
                                                    />
                                                    <div className="check-btn">
                                                        <ECheckIcon/>
                                                    </div>
                                                    <div className="payment-checkbox-inner">eCheck</div>
                                                </a>
                                            </li>)}
                                            <li
                                                className={classNames("nav-item chekbox-custom mr-2 me-2 rectangle nav-item-margin", paymentType === "creditCard" ? "active" : "")}
                                                role="presentation"
                                                onClick={() => updatePaymentType("creditCard")}
                                            >
                                                <a
                                                    className={`nav-link text-center`}
                                                    id="pills-profile-tab"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-profile"
                                                    role="tab"
                                                    aria-controls="pills-profile"
                                                    aria-selected="false"
                                                >
                                                    <CustomRadio
                                                        // defaultChecked={paymentType === "creditCard"}
                                                        checked={paymentType === "creditCard"}
                                                        onChange={(e) => updatePaymentType("creditCard")}
                                                    />
                                                    <div className="check-btn">
                                                        <CreditCardIcon/>
                                                    </div>
                                                    <div className="payment-checkbox-inner">
                                                        Credit/Debit Card
                                                    </div>
                                                </a>
                                            </li>
                                            <li
                                                className={classNames("nav-item chekbox-custom rectangle me-2 nav-item-margin", paymentType === "swipe" ? "active" : "")}
                                                role="presentation"
                                                onClick={() => updatePaymentType("swipe")}
                                            >
                                                <a
                                                    className={`nav-link text-center`}
                                                    id="pills-contact-tab"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-contact"
                                                    role="tab"
                                                    aria-controls="pills-contact"
                                                    aria-selected="false"
                                                >
                                                    <CustomRadio
                                                        // defaultChecked={paymentType === "swipe"}
                                                        checked={paymentType === "swipe"}
                                                        onChange={(e) => updatePaymentType("swipe")}
                                                    />
                                                    <div className="check-btn">
                                                        {/* <HhaCardIcon /> */}
                                                        <SwipeCardIcon
                                                            style={{width: "31px", height: "21px"}}
                                                        />
                                                    </div>
                                                    <div className="payment-checkbox-inner">
                                                        {/* HHA/HHS card */}
                                                        Tap/Insert/Swipe
                                                    </div>
                                                </a>
                                            </li>

                                        </ul>
                                        <div className="tab-content" id="pills-tabContent">
                                            <ECheckManualEntry
                                                paymentType={paymentType}
                                                payerUser={payerUser}
                                                accountType={accountType}
                                                handleInputChange={handleInputChange}
                                                handleSubmit={handleSubmit}
                                                isPaymentSaveDetails={isPaymentSaveDetails}
                                                setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                                                isDefault={isDefault}
                                                setIsDefault={setIsDefault}
                                                transactionLoading={transactionLoading}
                                            />

                                            {paymentGatewayType === 'NMI' &&
                                                <CreditCardManualNmiFields
                                                    buttonText={"Make a Payment"}
                                                    paymentGateways={adminUser?.paymentGateways}
                                                    paymentType={paymentType}
                                                    handleInputChange={handleInputChange}
                                                    handleSubmit={handleSubmit}
                                                    isPaymentSaveDetails={isPaymentSaveDetails}
                                                    setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                                                    isDefault={isDefault}
                                                    setIsDefault={setIsDefault}
                                                    transactionLoading={transactionLoading}
                                                    manual={manual}
                                                    showResult={showResult}
                                                />
                                            }
                                            {paymentGatewayType === 'converge' &&
                                                <CreditCardManualConvergeFields
                                                    paymentGateways={adminUser?.paymentGateways}
                                                    paymentType={paymentType}
                                                    handleInputChange={handleInputChange}
                                                    handleSubmit={handleSubmit}
                                                    isPaymentSaveDetails={isPaymentSaveDetails}
                                                    setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                                                    isDefault={isDefault}
                                                    setIsDefault={setIsDefault}
                                                    transactionLoading={transactionLoading}
                                                />
                                            }
                                            <DebitCardManualEntry
                                                paymentType={paymentType}
                                                handleInputChange={handleInputChange}
                                                isPaymentSaveDetails={isPaymentSaveDetails}
                                                setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                                                isDefault={isDefault}
                                                setIsDefault={setIsDefault}
                                                transactionLoading={transactionLoading}
                                            />
                                            {paymentGatewayType === 'NMI' &&
                                                <CreditCardSwipeEntryNmi
                                                    paymentGateways={adminUser?.paymentGateways}
                                                    handleInputChange={handleInputChange}
                                                    handleSubmit={handleSubmit}

                                                    paymentType={paymentType}

                                                    // handleInputChange={handleInputChange} commented out on 9/8/25
                                                    // handlePayNmi={handlePayNmi} commented out on 9/8/25
                                                    // firstName={firstName} commented out on 9/8/25
                                                    // lastName={lastName} commented out on 9/8/25

                                                    // lastFourNumbers={lastFourNumbers}
                                                    // disguisedSwipeNumber={disguisedSwipeNumber}
                                                    isPaymentSaveDetails={isPaymentSaveDetails}
                                                    setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                                                    isDefault={isDefault}
                                                    setIsDefault={setIsDefault}
                                                    transactionLoading={transactionLoading}
                                                    payerUser={payerUser}
                                                />}
                                            {paymentGatewayType === 'converge' &&
                                                <CreditCardSwipeEntryConverge
                                                    paymentType={paymentType}
                                                    handleInputChange={handleInputChange}
                                                    handlePay={handlePay}
                                                    firstName={firstName}
                                                    lastName={lastName}
                                                    lastFourNumbers={lastFourNumbers}
                                                    disguisedSwipeNumber={disguisedSwipeNumber}
                                                    isPaymentSaveDetails={isPaymentSaveDetails}
                                                    setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                                                    isDefault={isDefault}
                                                    setIsDefault={setIsDefault}
                                                    transactionLoading={transactionLoading}
                                                />}
                                        </div>
                                    </div>
                                </div>) : (<>
                                {(<>
                                    <div className="pay-saved-method">
                                        <div className="pay-patient-style">
                                            {payerUser?.paymentMethods?.length > 0 && `Saved Payment Methods`}
                                        </div>
                                        <div className="pay-toggleable d-flex row">

                                            {userAdmin.displayAddPaymentMethod && (<ul
                                                className="col-lg-5 col-md-4 col-xl-4 mb-3 nav nav-pills justify-content-center"
                                                // onClick={() => handleAddCardInfo()}
                                            >
                                                <li
                                                    className="nav-item custom-tab border-1 ml-8 custom-tab "

                                                    role="presentation"
                                                >
                                                    <a
                                                        className="nav-link text-center "
                                                        id="pills-home-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#pills-home"
                                                        role="tab"
                                                        aria-controls="pills-home"
                                                        aria-selected="true"
                                                    >
                                                        <div
                                                            className="check-btn mb-0 add-card-text">

                                                            <AddCardIcon
                                                                color="#fff"
                                                                fill="#6e86c4"
                                                                style={{
                                                                    marginRight: "6px", marginBottom: "2px"
                                                                }}
                                                            />
                                                            Add Payment Method
                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={(e) => handleSwipeAddCardInfo(e, "swipe")}
                                                            className="add-card-btn"
                                                        >
                                                            Swipe Credit/Debit
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={(e) => handleAddCardInfo(e)}
                                                            className="add-card-btn"
                                                        >
                                                            Credit/Debit Card
                                                        </button>
                                                        {adminUser && adminUser.displayECheck && (<button
                                                            type="button"
                                                            onClick={(e) => handleECheck(e)}
                                                            className="add-card-btn"
                                                        >
                                                            eCheck
                                                        </button>)}
                                                    </a>
                                                </li>
                                            </ul>)}
                                            {payerUser?.paymentMethods?.length > 0 &&

                                                map(payerUser.paymentMethods, (c, i) => {
                                                    let paymentMethodDisplay;
                                                    if (paymentGatewayType === 'NMI') {
                                                        if (c.cardType && c.cardNumber) {
                                                            let cardTypeDisplay = c.cardType?.toUpperCase();
                                                            if (cardTypeDisplay === 'MASTERCARD') {
                                                                cardTypeDisplay = 'MC';
                                                            }
                                                            paymentMethodDisplay = `${cardTypeDisplay} ${c.cardNumber}`;
                                                        }
                                                    }
                                                    if (paymentGatewayType === 'converge') {
                                                        if (c.ssl_card_short_description) {
                                                            paymentMethodDisplay = `${c.ssl_card_short_description} ${c.ssl_card_number.slice(-4)}`;
                                                        } else {
                                                            paymentMethodDisplay = `eCheck ${c.ssl_bank_account_number.slice(-4)}`;
                                                        }
                                                    }

                                                    return (<ul
                                                        key={i}
                                                        className="col-lg-5 col-md-4 col-xl-4 mb-3 nav nav-pills justify-content-center"
                                                        onClick={() => {
                                                            onClickPaymentMethod(c);
                                                        }}
                                                    >
                                                        <li
                                                            className={("nav-item custom-tab border-1 ml-8", selectedCardId === c._id ? " nav-item active select-card" : " nav-item custom-tab")}
                                                            role="presentation"
                                                        >
                                                            <a
                                                                className="nav-link text-center "
                                                                id="pills-home-tab"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#pills-home"
                                                                role="tab"
                                                                aria-controls="pills-home"
                                                                aria-selected="true"
                                                            >
                                                                <div
                                                                    className="check-btn d-flex mb-0">
                                                                    <CreditCardIcon/>
                                                                    <span
                                                                        className="text-dark payment-method-text">
                                                                    {paymentMethodDisplay}
                                              </span>
                                                                </div>
                                                                <div
                                                                    className="mb-0 ml-8 text-start text-dark mt-1">
                                                                    <label
                                                                        className="font-weight-light label-check sos-checkbox">
                                                                        <CustomCheckbox
                                                                            checked={c.isDefault}
                                                                            onChange={(e) => onDefaultChecked(e, c, i)}
                                                                        />

                                                                        <span
                                                                            className="payment-style payment-method-text">
                                                  Default Method
                                                </span>
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className="check-btn d-flex auto-payment text-dark">

                                                                </div>
                                                                <div className="divider"/>
                                                                <div
                                                                    className="d-flex cursor-pointer">
                                                                    {/*<span*/}
                                                                    {/*    className="text-cerulean text-decoration-underline ml-8"*/}
                                                                    {/*    onClick={() => handleEditInfo()}*/}
                                                                    {/*>*/}
                                                                    {/*  Edit*/}
                                                                    {/*</span>*/}
                                                                    <span
                                                                        className="text-cerulean text-decoration-underline custom-popup-modal"
                                                                        onClick={(e) => handlePopUp(e, c)}
                                                                    >
                                                Remove
                                              </span>
                                                                </div>
                                                            </a>
                                                        </li>
                                                    </ul>);
                                                })}
                                        </div>
                                    </div>
                                    {payerUser?.paymentMethods?.length > 0 &&
                                        <div className="d-flex justify-content-center">
                                            <button
                                                type="button"
                                                onClick={(e) => handleSubmit(e)}
                                                className="sos-mack-btn sos-custom-btn-css"
                                                disabled={transactionLoading}
                                            >
                                                {withButtonLoader("Process Payment", transactionLoading)}
                                            </button>
                                        </div>}
                                    {(adminUser.displayAddPaymentMethod || payerUser?.paymentMethods?.length > 0) &&
                                        <div className="pay-saved-inner-block">
                                            <div className="or-line"></div>
                                            <div className="payment-raound">
                                                <span>OR</span>
                                            </div>
                                        </div>}
                                </>)
                                    // : (
                                    //   ""
                                    // )
                                }
                                <div className="select-pay-method">
                                    <div className="pay-patient-style container">
                                        Pay With a New Payment Method
                                    </div>
                                    <div className=" pay-toggleable row">
                                        <ul
                                            className="mb-3 nav nav-pills p-0"
                                            id="pills-tab"
                                            role="tablist"
                                        >
                                            {adminUser.displayECheck && (<li
                                                className="me-5 nav-item chekbox-custom rectangle nav-item-margin"
                                                role="presentation"
                                                onClick={() => handleAmountBeingPaid("eCheck")}
                                            >
                                                <a
                                                    className={`nav-link text-center ${paymentType === "eCheck" ? "active" : ""}`}
                                                    id="pills-home-tab"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-home"
                                                    role="tab"
                                                    aria-controls="pills-home"
                                                    aria-selected="true"
                                                >
                                                    <div className="check-btn">
                                                        <ECheckIcon/>
                                                    </div>
                                                    <div className="payment-checkbox-inner">eCheck</div>
                                                </a>
                                            </li>)}
                                            <li
                                                className="me-5 nav-item chekbox-custom  rectangle nav-item-margin"
                                                role="presentation"
                                                onClick={() => handleAmountBeingPaid("creditCard")}
                                            >
                                                <a
                                                    className={`nav-link text-center ${paymentType === "creditCard" ? "active" : ""}`}
                                                    id="pills-profile-tab"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-profile"
                                                    role="tab"
                                                    aria-controls="pills-profile"
                                                    aria-selected="false"
                                                >
                                                    <div className="check-btn">
                                                        <CreditCardIcon/>
                                                    </div>
                                                    <div className="payment-checkbox-inner">
                                                        Credit/Debit Card
                                                    </div>
                                                </a>
                                            </li>
                                            <li
                                                className="nav-item chekbox-custom rectangle nav-item-margin"
                                                role="presentation"
                                                onClick={() => handleAmountBeingPaid("swipe")}
                                            >
                                                <a
                                                    className={`nav-link text-center ${paymentType === "swipe" ? "active" : ""}`}
                                                    id="pills-contact-tab"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-contact"
                                                    role="tab"
                                                    aria-controls="pills-contact"
                                                    aria-selected="false"
                                                >
                                                    <div className="check-btn">
                                                        {/* <HhaCardIcon /> */}
                                                        <div className="swipe-credit-card-icon">

                                                            <SwipeCardIcon
                                                                style={{width: "31px", height: "21px"}}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="payment-checkbox-inner">
                                                        {/* HHA/HHS card */}
                                                        Swipe Credit/Debit
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </>)}
                        </div>
                        <div className="hommeexisting-img">
                            <img src="/images/payment-icon.png" alt="homeExisting"/>
                        </div>
                    </div>}
                    {addEditSwipeMode === "edit" && <AdminEditCardInfo
                        payerUser={payerUser}
                        userAdmin={userAdmin}
                        setPayerUser={setPayerUser}
                        subdomain={subdomain}
                        paymentMethodData={selectedPayment}
                        setAddEditSwipeMode={setAddEditSwipeMode}
                    />}
                    {addEditSwipeMode === "add" && paymentGatewayType === 'converge' && <AdminAddCardInfo
                        userAdmin={userAdmin}
                        payerUser={payerUser}
                        setPayerUser={setPayerUser}
                        subdomain={subdomain}
                        paymentMethodData={selectedPayment}
                        setAddEditSwipeMode={setAddEditSwipeMode}
                        handleSwipeAddCardInfo={handleSwipeAddCardInfo}
                    />}

                    {(addEditSwipeMode === "add" || addEditSwipeMode === "swipe") && paymentGatewayType === 'NMI' && payerUser && Object.keys(payerUser).length > 0 &&
                        <AdminAddCardInfoNmi

                            openModal={openModal}
                            paymentMsg={paymentMsg}
                            onCloseModal={onCloseModal}

                            addEditSwipeMode={addEditSwipeMode}
                            setAddEditSwipeMode={setAddEditSwipeMode}
                            handleSwipeAddCardInfo={handleSwipeAddCardInfo}

                            adminUser={adminUser}
                            payerUser={payerUser}
                            paymentGateways={adminUser?.paymentGateways}
                            paymentType={paymentType}
                            handleInputChange={handleInputChange}
                            handleSubmit={handleSubmit}
                            isPaymentSaveDetails={isPaymentSaveDetails}
                            setIsPaymentSaveDetails={setIsPaymentSaveDetails}
                            isDefault={isDefault}
                            setIsDefault={setIsDefault}
                            transactionLoading={transactionLoading}
                            updatePaymentType={updatePaymentType}
                            manual={manual}
                            showResult={showResult}
                        />

                    }
                    {addEditSwipeMode === "swipe" && paymentGatewayType === 'converge' && <AdminPaymentAddSwipe
                        userAdmin={userAdmin}
                        payerUser={payerUser}
                        setPayerUser={setPayerUser}
                        subdomain={subdomain}
                        paymentMethodData={selectedPayment}
                        setAddEditSwipeMode={setAddEditSwipeMode}
                        handleAddCardInfo={handleAddCardInfo}
                    />}
                </div>
            </div>
        </div>

        <PaymentSuccessPopup
            openModal={openModal}
            paymentMsg={paymentMsg}
            onCloseModal={onCloseModal}
        />
        <CustomPopover
            flag={true}
            title={"Are you sure you want to remove this payment method?"}
            show={showPopUp}
            target={target}
            onRemove={onRemoveDoc}
            close={handleClosePopUp}
            setShowPopUp={setShowPopUp}
        />
        <CustomePopUp
            openModal={amountPaidPopup}
            onCloseModal={handleClosePopUp}
            message={"Please enter an amount."}
        />
    </>);
};

const mapDispatchToProps = {
    getPayerUserForAdminLookup, savePaymentsDataAdmin, deleteCard,
};

export default connect(null, mapDispatchToProps)(AdminPayerUser);
